import { isUndefined } from 'lodash-es';
import { useContext } from 'react';

import { XYChartAnnotationsIndicatorsContext } from '../context/XYChartAnnotationsIndicators.context.js';

export const useXYChartAnnotationsIndicators = () => {
  const context = useContext(XYChartAnnotationsIndicatorsContext);

  if (isUndefined(context)) {
    throw new Error(
      'useXYChartAnnotationsIndicators must be used within a XYChartAnnotationsIndicatorsProvider',
    );
  }
  return context;
};
